import { render, staticRenderFns } from "./ItemFileOrder.vue?vue&type=template&id=404a967d&scoped=true&"
import script from "./ItemFileOrder.vue?vue&type=script&lang=js&"
export * from "./ItemFileOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404a967d",
  null
  
)

export default component.exports